export class GragingCycles {
    TermDefinitionId: number;
    TermGradeCycleId: number;
    CurrentGradeCycle: string;
    GradingDescription: string;
    OverrideDescription: string;
    TermDescription: string;
    TermStartDate: Date;
    TermStopDate: Date;
    GradesPostOpen: Date;
    GradesPostClose: Date;
    Status: string;
    Classes: number;
    TotalClasses: number;
    AHRecords: number;
    IsCycleExists: boolean;
    CreatedBy: string;
    CreatedOn: Date;
    // NON DTO
    OldGradesPostOpen: Date;
    OldGradesPostClose: Date;
    GradesPostOpenBGColor: string;
    GradesPostCloseBGColor: string;
    SortingOrder = 0;
}

export class ClassPostingStatus {
    SiteSectionId: number;
    SubjectCode: string;
    SubjectTitle: string;
    Section: string;
    TeacherName: string;
    Meets: number;
    PostingComplete: string;
    StudentCount: number;
    StudentMissingGradeCount: number;
    // Non DTO
    PostingCompleteAsBool?: boolean;
}

export class StudentsWithoutTermRecords {
    TermGradeCycleId: number;
    StudentId: string;
    LngStudentId: number;
    CourseCode: string;
    CourseTitle: string;
    TeacherName: string;
    StudentFirstName: string;
    StudentMiddleName: string;
    StudentLastName: string;
    Section: string;
    EtryDate: Date;
    ExitDate: Date;
    // Non DTO
    IsSelected: boolean;
    isSelectedRow: boolean;
    StudentName: string;
}

export class ViewGradingCycleGrades {
    TermGradeId: number;
    TermGradeDetailId: number;
    TermGradeDetailTypeId: number;
    TermGradeCycleId: number;
    Course: string;
    CourseName: string;
    Section: string;
    Teacher: string;
    GradingColumn: string;
    StudentIdentifier: string;
    StudentLastName: string;
    StudentFirstName: string;
    StudentMiddleName: string;
    StudentId: number;
    Grade: string;
    Score: number;
    Comment: string;

    // Non-DTO field
    StudentName: string;
}

export class GradingCycleTerms {
    TermId: number;
    TermDescription: string;
    TermCodeSequence: string;
    TermValue: string;
    Caption: string;
    Prefix: string;
    PreviousTerm: boolean;
    CurrentGradeCycle: string;

    TermGradeDetailTypeId: number;
    TermGradeDetailTypeCode: string;
    TermGradesBehaviorSocialSkillsId: number;
    GradePercent: number;
    TermGradesTypeId: number;
    CreditEarnedOverride: number;
    CreditAttemptedOverride: number;
    WeightOverride: number;
    ExtraGradePointsOverride: number;
    HonorsOverride: number;
    UsedForHSTranscriptOverride: number;
    // ***
    CreditEarned: number;
    ModifiedCurriculum: boolean;
    InstructionalAdaptation: boolean;
    Comments: string;
    // Non DTO
    OldTermValue: string;
    OldGradePercentage: number;
}

export class GradingCycleClassPostingGrade {
    TermGradeCycleId: number;
    TermGradeId: number;
    SiteYearId: number;
    StudentId: number;
    StudentNumber: string;
    StudentFirstName: string;
    StudentMiddleName: string;
    StudentLastName: string;
    GradeLevelId: number;
    GradeLevel: string;
    SpecialPurpose: string;
    SpecialPurposeId: number;
    CitizenshipId: number;
    ModifiedCurriculum: boolean;
    InstructionalAdaptation: boolean;
    Comments: string;
    TeacherComment: boolean;
    UsingPercentageGrade: boolean;
    GradingCycleTerms: GradingCycleTerms[];
    SiteCode: string;
    SiteSectionId: number;
    // ***
    SubjectCode: string;
    SubjectTitle: string;
    SectionCode: string;
    TeacherName: string;
    CreditTerm: string;
    // NON DTO
    IsEdit: boolean;
    TotalCreditEarn: number;
}

export class GradingCycleCValidGrades {
    ValidGradeId: number;
    SiteYearId: number;
    ValidGrade: string;
    GradePoints: number;
    MinimumPercentage: number;
    TeacherUse: boolean;
    OverrideCode: boolean;
}

export class CurrentGradingCycleInfo {
    GradingDescription = '';
    ISCurrentCycleProgress = false;
    SelectedGradingCycleDescription = '';
    IsSelectedCycleProcess = false;
    IsUsingPercentageGrades = false;
}
